import React, { useState } from "react";
import LogoutModal from "../_common/logoutModal";
import { globalLoader, globalAlert } from "../../actions/commonActions";
import { userSelfDeleteConfirmApi } from "../../user/_userActions";
import { logOut } from "../../_shared/commonFunction";
import DeleteAccountModal from "./deleteAccountModal";
import { useTranslation } from "react-i18next";
import { appendPageLanguage } from "../../i18n/requestLanguage";

const AccountComponent = (props) => {
  const { t } = useTranslation();
  const [openDeleteAccModal, setOpenDeleteAccModal] = useState(false);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);

  const closeOpenDeleteAccModal = () => {
    setOpenDeleteAccModal(false);
  };

  const deleteAcc = async (obj) => {
    globalLoader(true);
    let res = await userSelfDeleteConfirmApi(obj);
    if (res?.data?.status === 200) {
      globalAlert("success", res?.data?.message);// eslint-disable-next-line
      props?.history?.push("/user/login");
    } else {
      globalAlert("error", res?.data?.message);
      globalLoader(false);
    }
  };

  const closeLogoutModal = (val) => {
    if (val) {
      logOut(props?.history, "/user/login");
    } else {
      setOpenLogoutModal(false);
    }
  };

  return (
    <div style={{ color: "#E5E5E5" }}>
      <div className="settings-wrapper mx-auto mx-md-auto">
        <div className="settings-menu mt-3 pt-2 px-3">
          <ul className="list-unstyled settings-menu-list">
            <li
              className="cursor"
              onClick={() => {
                // Opens a fresh browsing context with no router state, so the
                // language has to travel in the URL.
                window.open(
                  appendPageLanguage("/accessibility-statement"),
                  "_blank"
                );
              }}
            >
              <div className="settings-icons">
                <i className="fas fa-universal-access"></i>
              </div>
              <div>{t("common.accessibilityStatement")}</div>
            </li>
            <li
              className="cursor"
              onClick={() => {
                window.open("/privacy-policy", "_blank");
              }}
            >
              <div className="settings-icons">
                <i className="fas fa-user-shield"></i>
              </div>
              <div>{t("user.login.privacyPolicy")}</div>
            </li>
            <li
              className="cursor"
              onClick={() => {
                window.open("/user/terms-and-conditions", "_blank");
              }}
            >
              <div className="settings-icons">
                <i className="far fa-file-alt"></i>
              </div>
              <div>{t("user.account.termsAndConditions")}</div>
            </li>
            <li
              className="cursor"
              onClick={() => {
                setOpenLogoutModal(true);
                // logOut(props?.history, "/user/login");
              }}
            >
              <div className="settings-icons">
                <i className="fas fa-sign-out-alt"></i>
              </div>
              <div>{t("user.account.logout")}</div>
            </li>
            <li
              className="cursor "
              onClick={() => {
                setOpenDeleteAccModal(true);
              }}
            >
              <div className="settings-icons">
                <i className="far fa-trash-alt"></i>
              </div>
              <div>{t("user.account.deleteAccount")}</div>
            </li>
          </ul>
        </div>
      </div>
      {openDeleteAccModal && (
        <DeleteAccountModal
          open={openDeleteAccModal}
          closeModal={closeOpenDeleteAccModal}
          deleteAcc={deleteAcc}
        />
      )}
      {openLogoutModal && (
        <LogoutModal open={openLogoutModal} closeModal={closeLogoutModal} />
      )}
    </div>
  );
};

export default AccountComponent;
